// Mock data for development

// Mock projects
export const MOCK_PROJECTS = [
  {
    id: '1',
    name: 'Customer Churn Prediction',
    created_at: '2024-01-15T10:30:00Z',
    updated_at: '2024-01-20T14:22:00Z',
  },
  {
    id: '2',
    name: 'Sales Forecasting Model',
    created_at: '2024-01-10T09:15:00Z',
    updated_at: '2024-01-18T16:45:00Z',
  },
  {
    id: '3',
    name: 'Price Optimization',
    created_at: '2024-01-05T11:00:00Z',
    updated_at: '2024-01-12T10:30:00Z',
  },
  {
    id: '4',
    name: 'Fraud Detection System',
    created_at: '2024-01-01T08:00:00Z',
    updated_at: '2024-01-25T13:15:00Z',
  },
]

// Mock messages by project ID
const mockMessages = {
  1: [
    {
      id: 1,
      role: 'user',
      content: 'I want to predict customer churn based on usage patterns.',
      t: '2024-01-15T10:35:00Z',
    },
    {
      id: 2,
      role: 'assistant',
      content: 'I can help you build a churn prediction model. Let me analyze your data.',
      t: '2024-01-15T10:36:00Z',
    },
    {
      id: 3,
      role: 'system',
      content: 'Workflow started: wf-001',
      t: '2024-01-15T10:37:00Z',
    },
  ],
  2: [
    {
      id: 4,
      role: 'user',
      content: 'Create a sales forecasting model for Q1 2024',
      t: '2024-01-10T09:20:00Z',
    },
    {
      id: 5,
      role: 'assistant',
      content: 'I will help you forecast sales. Please upload your historical sales data.',
      t: '2024-01-10T09:21:00Z',
    },
  ],
  3: [],
  4: [],
}

// Mock project meta by project ID
const mockProjectMeta = {
  1: {
    target: 'churn',
    include_meta: true,
    columns_rows: [
      { name: 'customer_id', type: 'string', description: 'Unique customer identifier' },
      { name: 'age', type: 'numeric', description: 'Customer age' },
      { name: 'subscription_months', type: 'numeric', description: 'Months of subscription' },
      { name: 'churn', type: 'boolean', description: 'Churn status' },
    ],
    active_workflow_id: 'wf-001',
    last_workflow_id: 'wf-001',
    last_model: { type: 'classification', accuracy: 0.87 },
    last_input: { dataset_path: '/data/churn_dataset.csv' },
    updated_at: '2024-01-20T14:22:00Z',
  },
  2: {
    target: 'sales',
    include_meta: true,
    columns_rows: [
      { name: 'date', type: 'date', description: 'Sales date' },
      { name: 'product', type: 'string', description: 'Product name' },
      { name: 'sales', type: 'numeric', description: 'Sales amount' },
    ],
    active_workflow_id: null,
    last_workflow_id: null,
    last_model: null,
    last_input: null,
    updated_at: '2024-01-18T16:45:00Z',
  },
  3: {
    target: '',
    include_meta: true,
    columns_rows: [],
    active_workflow_id: null,
    last_workflow_id: null,
    last_model: null,
    last_input: null,
    updated_at: '2024-01-12T10:30:00Z',
  },
  4: {
    target: '',
    include_meta: true,
    columns_rows: [],
    active_workflow_id: null,
    last_workflow_id: null,
    last_model: null,
    last_input: null,
    updated_at: '2024-01-25T13:15:00Z',
  },
}

// Mock functions
let nextMessageId = 100
let nextProjectId = 100

export function getMockProject(id) {
  const project = MOCK_PROJECTS.find(p => String(p.id) === String(id))
  if (!project) return null
  return {
    ...project,
    owner_user_id: 1,
  }
}

export function createMockProject(name) {
  const now = new Date().toISOString()
  const newProject = {
    id: String(nextProjectId++),
    name: name.trim(),
    owner_user_id: 1,
    created_at: now,
    updated_at: now,
  }
  MOCK_PROJECTS.push(newProject)
  mockMessages[newProject.id] = []
  mockProjectMeta[newProject.id] = {
    target: '',
    include_meta: true,
    columns_rows: [],
    active_workflow_id: null,
    last_workflow_id: null,
    last_model: null,
    last_input: null,
    updated_at: now,
  }
  return newProject
}

export function getMockMessages(projectId) {
  return mockMessages[String(projectId)] || []
}

export function createMockMessage(projectId, role, content) {
  const projectIdStr = String(projectId)
  if (!mockMessages[projectIdStr]) {
    mockMessages[projectIdStr] = []
  }
  const newMessage = {
    id: nextMessageId++,
    role: role || 'user',
    content: content || '',
    t: new Date().toISOString(),
  }
  mockMessages[projectIdStr].push(newMessage)
  return newMessage
}

export function getMockProjectMeta(projectId) {
  const meta = mockProjectMeta[String(projectId)]
  if (!meta) {
    return {
      target: '',
      include_meta: true,
      columns_rows: [],
      active_workflow_id: null,
      last_workflow_id: null,
      last_model: null,
      last_input: null,
    }
  }
  return meta
}

export function saveMockProjectMeta(projectId, payload) {
  const projectIdStr = String(projectId)
  const existing = mockProjectMeta[projectIdStr] || {
    target: '',
    include_meta: true,
    columns_rows: [],
    active_workflow_id: null,
    last_workflow_id: null,
    last_model: null,
    last_input: null,
    updated_at: new Date().toISOString(),
  }

  const updated = {
    ...existing,
    target: payload.target !== undefined ? String(payload.target) : existing.target,
    include_meta: payload.include_meta !== undefined ? Boolean(payload.include_meta) : existing.include_meta,
    columns_rows: Array.isArray(payload.columns_rows) ? payload.columns_rows : existing.columns_rows,
    active_workflow_id:
      payload.active_workflow_id !== undefined
        ? payload.active_workflow_id
          ? String(payload.active_workflow_id)
          : null
        : existing.active_workflow_id,
    last_workflow_id:
      payload.last_workflow_id !== undefined
        ? payload.last_workflow_id
          ? String(payload.last_workflow_id)
          : null
        : existing.last_workflow_id,
    last_model: payload.last_model !== undefined ? payload.last_model : existing.last_model,
    last_input: payload.last_input !== undefined ? payload.last_input : existing.last_input,
    updated_at: new Date().toISOString(),
  }

  mockProjectMeta[projectIdStr] = updated
  return updated
}

// Mock workflow events by workflow ID
const mockWorkflowEvents = {
  'wf-001': [
    {
      id: 'ev-001',
      type: 'started',
      t: '2024-01-15T10:37:00Z',
    },
    {
      id: 'ev-002',
      type: 'router_decision',
      t: '2024-01-15T10:37:15Z',
      next_agent: 'demand',
      reason: 'Initial routing to demand analysis',
    },
    {
      id: 'ev-003',
      type: 'agent_notes',
      t: '2024-01-15T10:37:30Z',
      agent: 'demand',
      notes: 'Analyzing customer churn requirements and data structure',
    },
    {
      id: 'ev-004',
      type: 'validated',
      t: '2024-01-15T10:38:00Z',
    },
    {
      id: 'ev-005',
      type: 'router_decision',
      t: '2024-01-15T10:38:15Z',
      next_agent: 'analyst',
      reason: 'Requirements validated, proceeding to data analysis',
    },
    {
      id: 'ev-006',
      type: 'agent_notes',
      t: '2024-01-15T10:38:45Z',
      agent: 'analyst',
      notes: 'Examining dataset features and identifying key patterns for churn prediction',
    },
    {
      id: 'ev-007',
      type: 'callback',
      t: '2024-01-15T10:39:30Z',
    },
    {
      id: 'ev-008',
      type: 'router_decision',
      t: '2024-01-15T10:40:00Z',
      next_agent: 'designer',
      reason: 'Analysis complete, moving to model design',
    },
    {
      id: 'ev-009',
      type: 'agent_notes',
      t: '2024-01-15T10:40:30Z',
      agent: 'designer',
      notes: 'Designing gradient boosting model with feature engineering pipeline',
    },
    {
      id: 'ev-010',
      type: 'validated',
      t: '2024-01-15T10:41:00Z',
    },
    {
      id: 'ev-011',
      type: 'completed',
      t: '2024-01-15T10:41:30Z',
    },
  ],
}

// Mock workflow status by workflow ID
const mockWorkflowStatus = {
  'wf-001': {
    status: 'done',
    done: true,
    workflow_id: 'wf-001',
    artifacts: {
      model_uri: '/models/wf-001/model.pkl',
    },
  },
}

// Mock workflow snapshot by workflow ID
const mockWorkflowSnapshot = {
  'wf-001': {
    run_meta: {
      workflow_id: 'wf-001',
      started_at: '2024-01-15T10:37:00Z',
      finished_at: '2024-01-15T10:41:30Z',
    },
    input: {
      dataset_path: '/data/churn_dataset.csv',
      columns_schema: {
        customer_id: { type: 'string' },
        age: { type: 'int' },
        subscription_months: { type: 'int' },
        churn: { type: 'bool' },
      },
    },
    partials: {
      demand: {
        requirements: {
          target: 'churn',
        },
        questions: ['What is the business context?', 'Any specific constraints?'],
      },
      analyst: {
        notes: 'Dataset contains 10,000 records with 15 features',
      },
      designer: {
        models: [
          {
            model_type: 'gradient_boosting',
            metrics: [
              { metric_name: 'accuracy', metric_value: 0.87 },
              { metric_name: 'precision', metric_value: 0.85 },
              { metric_name: 'recall', metric_value: 0.82 },
            ],
          },
        ],
      },
      metrics: {
        accuracy: 0.87,
        precision: 0.85,
        recall: 0.82,
      },
    },
  },
}

export function getMockWorkflowEvents(workflowId) {
  const events = mockWorkflowEvents[workflowId] || []
  return { events }
}

export function getMockWorkflowStatus(workflowId) {
  return (
    mockWorkflowStatus[workflowId] || {
      status: 'running',
      done: false,
      workflow_id: workflowId,
    }
  )
}

export function getMockWorkflowSnapshot(workflowId) {
  return (
    mockWorkflowSnapshot[workflowId] || {
      run_meta: {
        workflow_id: workflowId,
        started_at: new Date().toISOString(),
      },
      input: {},
      partials: {},
    }
  )
}
